var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 89,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.315.092L122.592 0H97.04v3.92l6.528.484c7.318-.046 8.017 5.327 8.017 6.745 0 2.237-2.607 7.426-5.69 15.093l-18.14 44.53L65.3 16.741c-2.153-4.659-1.734-5.996-1.688-6.722.222-1.465.873-2.595 1.676-3.552.617-.726 2.187-2.064 3.863-2.064l6.748-.484V0H35.78C15.22 0 0 16.672 0 37.057v14.759C0 72.2 15.324 89 35.896 89h87.452c21.549 0 36.396-15.635 36.652-37.184V37.057c0-11.38-4.584-21.203-11.915-27.868-5.841-5.292-13.404-8.59-21.77-9.097zM35.686 84.596C17.5 84.596 4.328 69.94 4.328 51.919V37.162c0-18.01 13.172-32.757 31.358-32.757h2.327c3.596.081 5.736 1.177 7.284 2.41 1.583 1.257 3.13 3.84 4.62 7.656 1.116 2.94 1.942 5.062 2.466 6.272L78.97 84.584H35.686v.011zm119.788-32.677c0 17.445-12.124 32.665-31.94 32.665H87.231l22.748-56.37 5.445-13.283c1.338-3.309 3.538-6.93 5.341-8.613 1.757-1.637 3.851-1.902 6.306-1.902h-.128c13.207 0 28.531 13.202 28.531 32.757V51.93v-.011z",
    fill: "#000",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBig);
export default __webpack_public_path__ + "static/media/logo-big.852a60e7f7bacd3f82715b61e530baf1.svg";
export { ForwardRef as ReactComponent };